var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 53.389,
    viewBox: "0 0 80.053 53.389",
    width: 80.053,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1632.5 -69.99)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#ff8200",
    strokeMiterlimit: 10,
    strokeWidth: 5.337
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1635.168 70.01v53.369"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1709.884 70.01v53.369"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1637.837 72.679h16.011"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1653.847 72.679h58.705"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1632.5 120.711h80.053"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m1707.656 69.99-35.356 34.657-34.36-34.657h-5.22v2.31l39.677 40.3 37.486-37.3v-5.31z",
    fill: "#ff8200"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notification-icon.f0dbe490.svg";
export { ForwardRef as ReactComponent };